import React, {useEffect} from 'react';
import Nav from '../../Page Components/Nav';
import Footer from "../../Page Components/Footer";
import Card from "../../Co Components/SquareCards";
import Square from "../../Co Components/SquareCards";
import Title from "../../Co Components/Titles";
import homehero from '../../assets/Images/homehero.png';
import Rectangle from "../../Co Components/RectangleCards";
import LineButton from "../../Co Components/LineButton";
import hackerRed from '../../assets/Images/hacker.png';
import BlogCard from "../../Co Components/BlogCards";
import HomeCard from "../../Co Components/HomeCards";
import PrimaryButton from "../../Co Components/PrimaryButton";
import SecondaryButton from "../../Co Components/SecondaryButton";
const CodeReview = () => {
useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <section className={' d-flex flex-row mt-0  align-items-center w-90 '}>
                <article>
                    <div className={'mx-5 w-75'}>
                        <h1 className={'bebas display-1 text-black bolde  line-normal'}>WhiteGuard
                            <span className={'bebas red'}><br /> Source Code Review</span><br />
                            Services</h1>
                    </div>

                    <div className={'w-75 mx-5'}>
                        <p className={'bolder h6'} >
                        Our Red Team ensure that your application goes
under thorough analysis to discover security issues that can be easily
missed during the regular black box or even grey box penetration tests.
We have developed our own testing methodology that implements a
hybrid approach using a combination of high end automated tools and
exhaustive manual inspection to spot the light on the hard to find security
vulnerabilities and improve the security posture of your application.
                        </p>
                    </div>
                </article>
                <figure className=' headerImage align-self-center d-flex flex-column w-25'>
                    <HomeCard className={'danger'} />
                    <img src={hackerRed} className={'hackerImage z-1'} />
                </figure>

            </section>

            <Title className={'mt-6'} header={"the"} body={"Benefits"} />
            <div className={'d-flex mb-5 flex-row justify-content-center align-items-center flex-wrap'}>
                <Square className={'mx-4 cardRed mt-5'} Title={"Finding bugs early"} text={'Finding bugs early, when they are cheap to fix.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Coding standards compliance"} text={'Coding standards compliance. Code review helps to maintain consistent coding style across the company.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Teaching and sharing knowledge"} text={'Teaching and sharing knowledge. During review team members gain better understanding of the code base and learn from each other.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Consistent design and implementation"} text={'Consistent design and implementation. Peer review helps to maintain a level of consistency in software design and implementation.'} />

                <Square className={'mx-4 cardRed mt-5'} Title={"Higher software security"} text={'Higher software security. Applications that require a high level of security benefit from targeted security reviews.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Confidence of stakeholders"} text={'Confidence of stakeholders. You build confidence of stakeholders about the technical quality of the execution.'} />
            </div>
            {/*<Title className={'mt-6'} header={"the"} body={"Process"} />*/}
            {/*<div className={'d-flex mb-12 flex-column align-items-center justify-content-start process-container'} style={{ transition: 'all 0.3s ease' }}>*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Goal Setting'} text={'Customer asks the red team to determine if a threat agent can access specific assets.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Reconnaissance'} text={'Red team identifies network services, web applications, and employee portals.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Penetration Testing Exercise'} text={'Network service exploitation:'*/}
            {/*         +' Exploiting unpatched or \n' +*/}
            {/*        'misconfigured network services.\n' +*/}
            {/*        '\n Application layer exploitation: Web applications are often\n' +*/}
            {/*        'the first thing an attacker sees when looking at an organization’s\n' +*/}
            {/*        'network perimeter.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Phishing Exercise'} text={'Email and phone-based social engineering. With a little \n' +*/}
            {/*        'bit of research on individuals or organizations, phishing emails become a lot more convincing. This low hanging fruit is frequently the first in a\n' +*/}
            {/*        ' chain of composite attacks that lead to the goal.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Physical Exercise'} text={'Physical facility exploitation. People have a natural\n' +*/}
            {/*        'inclination to avoid confrontation. Thus, gaining access to a secure\n' +*/}
            {/*        'facility is often as easy as following someone through a door.'} />*/}
            {/*</div>*/}


            <Footer />
        </>
    );

}

export default CodeReview;